
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InitiatorRoutingModule } from './initiator.routing';
import { InitiatorChangePwdComponent } from './initiatorchangepwd.component';
import { InitiatorCollaboComponent } from './initiatorcollabo.component';
import { InitiatorDashboardComponent } from './initiatordashboard.component';
import { InitiatorHeadComponent } from './initiatorhead.component';
import { InitiatorMessageComponent } from './initiatormessage.component';
import { InitiatorMyaccountComponent } from './initiatormyaccount.component';
import { InitiatorPostcollaboComponent } from './initiatorpostcollabo.component';
import {CdkAccordionModule} from '@angular/cdk/accordion';

import { CostComponent } from './cost.component';

import { PayComponent } from './pay.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {MessagesComponent} from './messages/messages.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip'
import {MatRadioModule} from '@angular/material/radio';
import { NgSelectModule } from '@ng-select/ng-select';
import { SocialLogins } from '../../sociallogins';
import { ModalModule } from 'ngx-bootstrap/modal';

import { CollapseModule } from 'ngx-bootstrap/collapse';
@NgModule({
    imports: [ CommonModule,InitiatorRoutingModule,MatExpansionModule,ModalModule,MatTooltipModule ,CdkAccordionModule,FormsModule,MatAutocompleteModule,MatFormFieldModule,MatSelectModule,MatRadioModule,NgSelectModule,ReactiveFormsModule,
        CollapseModule.forRoot()],
    exports: [],
    declarations: [ InitiatorHeadComponent,InitiatorPostcollaboComponent,InitiatorCollaboComponent,
        InitiatorMessageComponent,InitiatorDashboardComponent,PayComponent, CostComponent,
        InitiatorChangePwdComponent,InitiatorMyaccountComponent,MessagesComponent ],
    providers: [SocialLogins],
})
export class InitiatorModule { }
